import { render, staticRenderFns } from "./McmPageFooter.vue?vue&type=template&id=0450557e&scoped=true&"
import script from "./McmPageFooter.ts?vue&type=script&lang=ts&"
export * from "./McmPageFooter.ts?vue&type=script&lang=ts&"
import style0 from "./McmPageFooter.vue?vue&type=style&index=0&id=0450557e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0450557e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFooter } from 'vuetify/lib/components/VFooter';
installComponents(component, {VFooter})
